import { CustomUmbrella } from "@/models/configurator/custom_umbrella";
import axios, { AxiosResponse } from "axios";
import { APIError, BadRequest, NotFoundError } from "./error_service";

// import { AuthError, APIError } from "@/services/error_service";

/**
 * Creates a new Config File Service

 * @example
 * const specService = new SpecService();
 * specService.getFile();
 */

// axios.defaults.headers.apikey = process.env.VUE_APP_API_KEY;
// axios.defaults.withCredentials = true;
// axios.defaults.headers.apikey = process.env.VUE_APP_API_LARAVEL_APIKEY;
axios.defaults.withCredentials = false;

export default class SpecService {
  /**
   *
   */

  // JM: This service is used to download the spec sheet of the custom umbrella from the Laravel API
  public async downloadSpecs(req: {
    images: string[];
    specs: CustomUmbrella;
  }): Promise<Blob> {
    let pdf;
    const url = process.env.VUE_APP_API_LARAVEL_URL + "/api/export_pdf";

    try {
      const res = await axios.post(url, req, {
        headers: {
          Authorization: `Bearer ${process.env.VUE_APP_API_LARAVEL_APIKEY}`,
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        responseType: "blob"
      });

      pdf = res.data;
    } catch (err: any) {
      const status = err.response?.status;
      const message = err.response?.data?.message || "Something went wrong, please try again.";

      if (status === 400) {
        throw new BadRequest(message, status);
      } else {
        throw new APIError(message, status);
      }
    }

    return pdf;
  }

  // OLD: This method was commented out because it is not used in the application.
  // public async downloadSpecs(req: {
  //   images: string[];
  //   specs: CustomUmbrella;
  // }): Promise<Blob> {
  //   let pdf;
  //   const url = process.env.VUE_APP_API_NODE_URL + "/specs";
  //   try {
  //     const options = {
  //       withCredentials: true
  //     };
  //     const res: AxiosResponse = await axios.post(url, req, {
  //       responseType: "blob"
  //     });
  //     pdf = res.data;
  //   } catch (err) {
  //     if (err.response && err.response.status === 400) {
  //       throw new BadRequest(
  //         "Configuration file not found.",
  //         err.response.status
  //       );
  //     } else {
  //       if (err.response && err.response.status === 400) {
  //         throw new BadRequest(err.response.data.message, err.response.status);
  //       } else {
  //         throw new APIError(
  //           "Something went wrong, please try again.",
  //           err.response.status
  //         );
  //       }
  //     }
  //   }
  //   return pdf;
  // }
}
